// Components
import { StreamField } from 'components/staticpages/streamfield'
import { SidebarLayout } from 'components/staticpages/sidebarlayout'

// Types
import { CmsPage } from 'types'

type BasicStreamFieldPageProps = {
  page: CmsPage
}

const BasicStreamFieldPage = ({ page }: BasicStreamFieldPageProps): JSX.Element => (
  <div>
    {page && page.meta.type === 'cms.SidebarLayout' ? (
      <SidebarLayout title={page.title} content={page.content} sidebarContent={page.sidebar_content} />
    ) : (
      <StreamField blocks={page?.content} />
    )}
  </div>
)

export default BasicStreamFieldPage
